export default "__VITE_ASSET__CBQDMF4t__"